import axios from "axios";

const configuredBackendUrl = String(process.env.REACT_APP_BACKEND_URL || "")
  .trim()
  .replace(/\/+$/, "")
  .replace(/\/api$/, "");

// Production deployments proxy the backend under the same origin. Keep an
// explicit backend URL for local/split-host environments, but never emit
// `undefined/api` when a deployment omits the build-time variable.
export const API = `${configuredBackendUrl}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("okkax_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  if (detail?.msg) return detail.msg;
  return e?.message || "Terjadi kesalahan.";
}

export const idr = (n) =>
  "Rp" + new Intl.NumberFormat("id-ID", { maximumFractionDigits: 0 }).format(Math.round(n || 0));

export const compact = (n) => {
  const v = Number(n || 0);
  if (Math.abs(v) >= 1e12) return `Rp${(v / 1e12).toFixed(2)} T`;
  if (Math.abs(v) >= 1e9) return `Rp${(v / 1e9).toFixed(2)} M`;
  if (Math.abs(v) >= 1e6) return `Rp${(v / 1e6).toFixed(1)} jt`;
  return idr(v);
};

export const num = (n) => new Intl.NumberFormat("id-ID").format(Math.round(n || 0));

export const DISCLAIMER =
  "Seluruh nama, organisasi, talent, harga, rider, transaksi, tiket, dan metrik pada mode demo merupakan data fiktif untuk keperluan demonstrasi kompetisi.";
export const SANDBOX_NOTICE = "Mode demo kompetisi. Tidak ada uang nyata yang akan ditagihkan.";
export const LOGO_URL = "/assets/okkax-wordmark-v3.png";
export const LOGO_MARK_URL = "/assets/okkax-x-mark-v3.png";

export const DEMO_EVENT_ID = "evt-aruna-2026";

export async function downloadDoc(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

// In-flight promise deduplication & lightweight memory cache
const requestCache = new Map();

export async function fetchCached(url, ttlMs = 60_000) {
  const now = Date.now();
  const hit = requestCache.get(url);
  if (hit && now - hit.time < ttlMs) {
    return hit.promise;
  }
  const promise = api.get(url).then((res) => res.data).catch((err) => {
    requestCache.delete(url);
    throw err;
  });
  requestCache.set(url, { time: now, promise });
  return promise;
}
